export { CollectibleSceneDetails } from './CollectibleSceneDetails'
